"use client"
import { isDJUIEnabled, setDJUIFeature } from "@/lib/featureFlags.utils"
import { MenuItem } from "@mantine/core"
import { IconGitCompare } from "@tabler/icons-react"

export function MenuItemToggleDJUIButton() {
  const isDJUIFeatureEnabled = isDJUIEnabled()

  return (
    <MenuItem
      leftSection={<IconGitCompare className={"size-4"} />}
      onClick={() => {
        setDJUIFeature(isDJUIFeatureEnabled ? "disabled" : "enabled")
        // We need to perform a full page reload to ensure that the new UI is loaded
        window.location.reload()
      }}
    >
      {isDJUIFeatureEnabled ? "Disable" : "Try"} the new UI
    </MenuItem>
  )
}
